export const COGNITO_CHALLENGE_REQUIRE_PASSWORD = 'NEW_PASSWORD_REQUIRED';
